export const APP_NAME = "fatbastardpies voucher";
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const Z_INDEX_LOADING = 20;

export const SERVER_URL = "https://api.fatbastardpies.nz";

// export const SERVER_URL = IS_DEVELOPMENT
//   ? "http://127.0.0.1:5000"
//   : "https:/club.fatbastardpies.nz";

export const STRIPE_SECRET_LIVE_KEY =
  "pk_live_51K6r9sFiLCGwtCZl8Cxg080dWYEDUwG4lPNZNHJdO5BfKIVjtJ9dxb3PVlvVvO46GumvLEdElQqXRPReSBp8EzC900ktX9vnaX";

// export const STRIPE_SECRET_LIVE_KEY =
//   "pk_test_51K6r9sFiLCGwtCZlLNzragfMa1V7z1qIBk0gRn9eZWul1VinIfkajHSVMhtcHC4mdQVvXV7WdtklcE7tKtUdD8Hz00PcWfOYBg";
